module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group esma_form_group"
  }, [_c('label', {
    class: {
      'col-xs-4': true, 'control-label': true, 'esma_form_label': true, 'esma_error_field': _vm.showAsError
    },
    style: (_vm.labelStyle),
    attrs: {
      "for": _vm.fieldID
    }
  }, [_vm._v("\n   " + _vm._s(_vm.fieldLabel) + " "), (_vm.isRequired) ? _c('span', {
    staticClass: "is_required",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("＊")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "padding": "1px 0px 1px 7px"
    }
  }, [_c('input', {
    ref: "local_value",
    staticClass: "form-control",
    style: (_vm.filedStyle),
    attrs: {
      "type": "password",
      "disabled": _vm.isDisabled,
      "autocapitalize": "none",
      "_autocomplete": "off",
      "autocomplete": "new-password",
      "id": _vm.fieldID,
      "name": _vm.fieldID,
      "placeholder": ""
    },
    domProps: {
      "value": _vm.fieldValue
    },
    on: {
      "focus": function($event) {
        _vm.atFocus()
      },
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0adefa2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/password-box.vue
// module id = 1058
// module chunks = 0